export type ProjectListParams = {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
};

/**
 * Central query-key factory. Keeping the hierarchy here makes broad cache
 * invalidation intentional while preserving exact keys for resource updates.
 */
export const queryKeys = {
  projects: {
    all: ['projects'] as const,
    complete: ['projects', 'complete'] as const,
    list: (params?: ProjectListParams) => ['projects', params] as const,
    detail: (id: string | undefined) => ['project', id] as const,
  },
  projectViews: {
    all: ['projectViews'] as const,
    list: (projectId: string | undefined) => ['projectViews', projectId] as const,
  },
  tasks: {
    my: ['myTasks'] as const,
    projectLists: ['projectTasks'] as const,
    project: (projectId: string | undefined) => ['projectTasks', projectId] as const,
    detail: (id: string | undefined) => ['task', id] as const,
  },
  teams: {
    all: ['teams'] as const,
  },
  users: {
    all: ['users'] as const,
    complete: ['users', 'complete'] as const,
  },
  analytics: {
    overview: ['analyticsOverview'] as const,
  },
  dashboard: {
    layout: ['dashboardLayout'] as const,
  },
} as const;
